<a  target="_blank" href="{{instagram.href}}"  [ngClass]="{'is-loaded':isLoaded}">
    <img (load)="instaImageLoaded()" src="{{instagram.img}}" alt="{{instagram.alt}}">
</a>